import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IListApiModel } from '../models/api.model';
import { IVsmGroup } from '../models/vsm.model';

@Injectable()
export class VsmService {
  constructor(private readonly http: HttpClient) {}

  updateVsmGroupName(
    id: number,
    name: string
  ): Observable<{ success: boolean; id: number }> {
    return this.http.put<{ success: boolean; id: number }>(
      `${environment.apiUrl}/v1/vsm/${id}`,
      {
        name,
        members: null,
        empty_members: false,
      }
    );
  }

  createVsmGroup(name: string): Observable<{ success: boolean; id: number }> {
    return this.http.post<{ success: boolean; id: number }>(
      `${environment.apiUrl}/v1/vsm`,
      {
        name,
        members: [],
      }
    );
  }

  deleteVsmGroup(id: number): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(
      `${environment.apiUrl}/v1/vsm/${id}`
    );
  }

  toggleVsmGroupManager(
    id: number,
    accountId: number
  ): Observable<{ success: boolean }> {
    return this.http.put<{ success: boolean }>(
      `${environment.apiUrl}/v1/vsm/${id}/manager`,
      {
        account_id: accountId,
      }
    );
  }

  updateVsmGroupMembers(
    id: number,
    members: number[]
  ): Observable<{ success: boolean; id: number }> {
    return this.http.put<{ success: boolean; id: number }>(
      `${environment.apiUrl}/v1/vsm/${id}`,
      {
        members: members.map(i => i.toString()),
      }
    );
  }

  emptyVsmGroupMembers(
    id: number
  ): Observable<{ success: boolean; id: number }> {
    return this.http.put<{ success: boolean; id: number }>(
      `${environment.apiUrl}/v1/vsm/${id}`,
      {
        members: null,
        empty_members: true,
      }
    );
  }

  getVsms(): Observable<IListApiModel<IVsmGroup>> {
    return this.http.get<IListApiModel<IVsmGroup>>(
      `${environment.apiUrl}/v1/vsm`
    );
  }

  vsmGroupInfo(id: number): Observable<IVsmGroup> {
    return this.http.get<IVsmGroup>(`${environment.apiUrl}/v1/vsm/${id}`);
  }
}
